import React from "react";
import {Route, Switch} from "react-router-dom";

import CompanyList from "../../containers/yotta/company/cominfo/list";
import NewCompany from "../../containers/yotta/company/cominfo/new";
import NewCompanyType from "../../containers/yotta/company/type/new";
import CompanyTypes from "../../containers/yotta/company/type/list";
import NewMigrationRequest from "../../containers/yotta/company/mirgration/NewMigrationRequest";
import EditMigrationRequest from "../../containers/yotta/company/mirgration/EditMigrationRequest";
import MigrationHistory from "../../containers/yotta/company/mirgration/MigrationHistory";
import MigrationRequestDetails from "../../containers/yotta/company/mirgration/MigrationRequestDetails";

const Company = ({match}) => (
    <Switch>
        <Route path={`${match.url}/companylists`} component={CompanyList}/>
        <Route path={`${match.url}/newcompany`} component={NewCompany}/>
        <Route path={`${match.url}/companyedit/:id`} component={NewCompany}/>
        <Route path={`${match.url}/newcomtype`} component={NewCompanyType}/>
        <Route path={`${match.url}/alltype`} component={CompanyTypes}/>
        <Route path={`${match.url}/comtypeedit/:id`} component={NewCompanyType}/>
        <Route path={`${match.url}/newmigrationrequest`} component={NewMigrationRequest}/>
        <Route path={`${match.url}/editmigrationrequest/:id`} component={EditMigrationRequest}/>
        <Route path={`${match.url}/migrationrequestdetails/:id`} component={MigrationRequestDetails}/>
        <Route path={`${match.url}/migrationhistory`} component={MigrationHistory}/>
    </Switch>
);

export default Company;
